/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {CacheScope, CacheTTL} from '@adobe/exc-app/cache';
import {CJA_PERMISSIONS_QUERY} from '@exc/graphql/src/queries/cja-permissions';
import type {CJAPermissions, CJAPermissionsVariables} from '@exc/graphql/src/models/cja-permissions';
import DataPrefetchContract from '@adobe/exc-app/network/DataPrefetchContract';
import {FetchScope} from '@adobe/exc-app/network';

export const PERMISSIONS_PREFETCH_KEY = 'cja-permissions-org';

const CJA_PERMISSIONS_VARIABLES: CJAPermissionsVariables = {
  limit: 10,
  permissions: ['Omni.Tools.AIAssistantDocumentation']
};

const gqlDef = {
  dataPath: 'getCJAPermissions',
  fetchScope: FetchScope.ORG,
  query: CJA_PERMISSIONS_QUERY,
  variables: CJA_PERMISSIONS_VARIABLES
};

export const cjaPermissionsContract: DataPrefetchContract<CJAPermissions> = {
  defaultValue: {permissions: []},
  expiry: CacheTTL.MONTH,
  gql: gqlDef,
  isSensitive: false,
  key: PERMISSIONS_PREFETCH_KEY,
  refreshData: {
    gql: gqlDef
  },
  revalidate: {
    enabled: true
  },
  scope: CacheScope.ORG,
  shared: true
};
